export default __webpack_public_path__ + "6bb653fdde1024fd7d183a49477922c4.svg";